
require ('./src/js/tabler.esm');
var $ = require("jquery");
window.jQuery = $;
window.$ = $;